import React, { useRef, lazy } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function MegaKitSection() {
  const checkoutUrl = 'https://magiadigital.online/checkouts/cn/hWN9TYd7nIHOv98RJ6pjImQM/es-ar?_r=AQABPAMwqwcFHsaNx77xI9-vQVNjUUJUKqqMcQTwOKcBl4s&preview_theme_id=158917099778';
  const collageUrl = 'https://cdn.magicpatterns.com/uploads/ietsRzgTArHniV3NYUhdp9/il_570xN.6630464415_bgu3.webp';
  const mockupUrl = 'https://cdn.magicpatterns.com/uploads/2bhUqhVfWCjsiC5Nb3JXQb/Party-Favor-Templates-Mockup-Bundle-5x7-CANVA_use_1200x.webp';
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const items = ['26 carpetas con +1000 archivos cada una', 'Invitaciones editables', 'Banderines decorativos', 'Topper para torta', 'Decoración de mesa', 'Números 3D', 'Flores de papel', 'Plantillas listas para imprimir'];
  return <section className="w-full bg-white py-20 sm:py-28 overflow-hidden" data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref} data-id="element-144">
        <div className="text-center mb-16" data-id="element-145">
          <motion.h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-slate-900 mb-4" initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6
        }} data-id="element-146">
            🎁 Todo lo que incluye el pack
          </motion.h2>
          <motion.p className="text-xl sm:text-2xl font-bold text-rose-500" initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-147">
            26 carpetas con más de 1000 archivos cada una
          </motion.p>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-148">
          {/* Content Column */}
          <div className="flex-1 w-full order-2 lg:order-1" data-id="element-149">
            <motion.div className="bg-white border-2 border-rose-100 rounded-3xl p-8 shadow-xl" initial={{
            opacity: 0,
            x: -30
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-150">
              <ul className="space-y-4 mb-8" data-id="element-151">
                {items.map((item, i) => <motion.li key={i} className="flex items-center gap-3" initial={{
                opacity: 0,
                x: -10
              }} animate={isInView ? {
                opacity: 1,
                x: 0
              } : {}} transition={{
                duration: 0.3,
                delay: 0.3 + i * 0.05
              }} data-id="element-152">
                    <div className="flex-shrink-0 w-6 h-6 bg-green-100 rounded-full flex items-center justify-center" data-id="element-153">
                      <CheckIcon className="w-4 h-4 text-green-600" data-id="element-154" />
                    </div>
                    <span className="text-slate-700 font-medium text-lg" data-id="element-155">
                      {item}
                    </span>
                  </motion.li>)}
              </ul>

              <div className="bg-rose-50 rounded-xl p-4 text-center mb-8" data-id="element-156">
                <p className="text-rose-600 font-bold text-xl" data-id="element-157">
                  🎉 El kit imprimible más completo.
                </p>
              </div>

              <div className="text-center" data-id="element-158">
                <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="shimmer-btn inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-rose-500 to-pink-500 text-white text-lg font-bold rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 w-full" data-id="element-159">
                  👉 Descargar el Mega Kit — $27.990 ARS
                </a>
                <p className="mt-4 text-sm font-semibold text-slate-500" data-id="element-160">
                  💻 Descarga inmediata después de comprar
                </p>
              </div>
            </motion.div>
          </div>

          {/* Images Column */}
          <div className="flex-1 relative w-full order-1 lg:order-2" data-id="element-161">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={isInView ? {
            opacity: 1,
            scale: 1
          } : {}} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="space-y-6" data-id="element-162">
              <img src={collageUrl} alt="" className="w-full h-auto rounded-3xl shadow-xl object-cover border-4 border-white" loading="lazy" data-id="element-163" />
              <img src={mockupUrl} alt="" className="w-3/4 mx-auto h-auto rounded-2xl shadow-2xl object-cover border-4 border-white" loading="lazy" data-id="element-164" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}